import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import Modal from 'components/Modal';
import { Text, Button } from 'components/ui';
import LoyaltyConnectionEN from 'components/LoyaltyConnection/locales/LoyaltyConnection_en_US';
import LoyaltyConnectionFR from 'components/LoyaltyConnection/locales/LoyaltyConnection_fr_CA';

/**
 * Link-failure popup for the Sephora x Starbucks loyalty flow (Figma 3132-74072).
 * Shown when linking fails — either the initiateAccountLink mutation errored, or
 * the partner OAuth flow returned to the page with ?isSuccess=false (LC-145).
 */
const LinkErrorModal = ({ isOpen, onDismiss }) => {
    const getText = localeUtils.getLocalisedDataFromResource(LoyaltyConnectionEN, LoyaltyConnectionFR);

    return (
        <Modal
            isOpen={isOpen}
            onDismiss={onDismiss}
            maxWidth={['100%', '100%', 460]}
            isDrawer={true}
        >
            <Modal.Header>
                <Modal.Title>{getText('linkModalTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body paddingBottom={[5, 5, 6]}>
                <Text
                    is='p'
                    fontSize='sm'
                    lineHeight='normal'
                    marginBottom={4}
                    data-at={Sephora.debug.dataAt('starbucks_link_error_body')}
                >
                    {getText('linkErrorBody')}
                </Text>

                <Button
                    variant='primary'
                    width='100%'
                    onClick={onDismiss}
                    data-at={Sephora.debug.dataAt('starbucks_link_error_ok_button')}
                >
                    {getText('linkErrorDismiss')}
                </Button>
            </Modal.Body>
        </Modal>
    );
};

export default wrapFunctionalComponent(LinkErrorModal, 'LinkErrorModal');
